<template>
  <div class="addCustomer main">
    <van-form @submit="onSubmit" validate-first v-if="allData">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="基本信息" name="1">
          <template #title>
            <div class="title">基本信息</div>
          </template>
          <template #value>
            <div class="right">
              <template v-if="activeNames.indexOf('1') != -1">收起<img src="@static/images/business/icon-arrow-up.png" alt="" /></template>
              <template v-else><span grey>展开</span><img src="@static/images/business/icon-arrow-down.png" alt="" /></template>
            </div>
          </template>
          <van-field
            v-model="formData.name"
            :maxlength="10"
            name="姓名"
            label="姓名"
            placeholder="必填"
            required
            :rules="[{ required: true, message: '请填写用户名' }]"
          />
          <van-field
            v-if="canEdit"
            v-model="formData.mobile"
            type="tel"
            name="手机号"
            label="手机号"
            placeholder="必填"
            required
            :rules="[{ validator: validatorPhone, required: true, message: '请输入正确的手机号', trigger: 'onBlur' }]"
          >
            <template #right-icon>
              <span v-if="formData.visitorId && $config.isApp" class="import" @click="importCustomer">通讯录导入</span>
              <!-- <span v-if="formData.visitorId" class="import" @click="importCustomer">通讯录导入</span> -->
            </template>
          </van-field>
          <van-field v-model="formData.remark" type="textarea" name="备注" rows="3" label="备注" placeholder="请输入" :maxlength="50" />
          <van-field
            v-if="CARD_TYPE"
            readonly
            clickable
            name="picker"
            :value="CARD_TYPE[formData.cardType]"
            label="证件类型"
            placeholder="请选择"
            @click="showPicker = true"
          >
            <template #right-icon>
              <img class="icon-arrow-down-select" src="@static/images/business/icon_arrow_down_grey.png" alt="" />
            </template>
          </van-field>
          <!-- <van-field v-model="formData.cardNo" clearable
						:rules="[{ validator: validatorSfz, message: '请输入正确的证件号', trigger: 'onBlur' }]" type="text"
						name="证件号" label="证件号" placeholder="请输入" /> -->
          <van-field
            v-if="formData.eyeShow1 || !cardNoEye"
            @input="changeCardNo()"
            v-model="formData.cardNoUpdate"
            clearable
            :rules="[{ validator: validatorSfz, message: '请输入正确的证件号', trigger: 'onBlur' }]"
            type="text"
            name="证件号"
            label="证件号"
            placeholder="请输入"
          >
            <template #right-icon v-if="formData.cardNo && cardNoEye">
              <van-icon class="password-icon" @click="openEye(formData, 'eyeShow1', 'cardNo')" name="eye-o" />
            </template>
          </van-field>
          <van-field
            v-else
            v-model="formData.cardNo"
            @input="changeCardNo()"
            clearable
            :rules="[{ validator: validatorSfz, message: '请输入正确的证件号', trigger: 'onBlur' }]"
            type="text"
            name="证件号"
            label="证件号"
            placeholder="请输入"
          >
            <template #right-icon v-if="formData.cardNo">
              <van-icon class="password-icon" @click="openEye(formData, 'eyeShow1', 'cardNo')" name="closed-eye" />
            </template>
          </van-field>
          <van-field name="radio" label="性别" class="radio-wrap">
            <template #input>
              <van-radio-group v-model="formData.sex" direction="horizontal">
                <van-radio v-for="(item, sexIndex) in sexColumns" :key="sexIndex" :name="item.key">
                  {{ item.text }}
                </van-radio>
                <!-- <van-radio :name="2">女</van-radio> -->
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="formData.birthDate"
            label="生日"
            placeholder="请选择"
            @click="showPickerBirthFn('birthDate')"
            ><template #right-icon>
              <img class="icon-arrow-down-select" src="@static/images/business/icon_arrow_down_grey.png" alt="" /> </template
          ></van-field>
          <!-- <van-field v-model="formData.age" type="number" name="年龄" label="年龄" placeholder="请输入" /> -->
          <van-field name="radio" label="证件有效期" class="radio-wrap" v-if="formData.cardType != '06'">
            <template #input>
              <van-radio-group v-model="formData.isLong" direction="horizontal">
                <van-radio v-for="(item, isLongIndex) in isLongColumns" :key="isLongIndex" :name="item.key">{{ item.text }} </van-radio>
                <!-- <van-radio :name="0">非长期</van-radio> -->
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            name="datetimePicker"
            :value="formData.cardStartDate"
            label="起始日期"
            placeholder="请选择"
            @click="showPickerBirthFn('cardStartDate')"
            v-if="formData.cardType != '06'"
          >
            <template #right-icon>
              <img class="icon-arrow-down-select" src="@static/images/business/icon_arrow_down_grey.png" alt="" />
            </template>
          </van-field>
          <van-field
            v-if="formData.isLong != 1 && formData.cardType != '06'"
            readonly
            clickable
            name="datetimePicker"
            :value="formData.cardEndDate"
            label="终止日期"
            placeholder="请选择"
            @click="showPickerBirthFn('cardEndDate')"
          >
            <template #right-icon>
              <img class="icon-arrow-down-select" src="@static/images/business/icon_arrow_down_grey.png" alt="" />
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            name="area"
            :value="formData.province + ' ' + formData.city + ' ' + formData.area"
            label="地区选择"
            placeholder="点击选择省市"
            @click="showDatas(1)"
            ><template #right-icon>
              <img class="icon-arrow-down-select" src="@static/images/business/icon_arrow_down_grey.png" alt="" />
            </template>
          </van-field>
          <!-- <van-field v-model="formData.address" :maxlength="50" type="textarea" name="详细地址" rows="3"
						label="详细地址" placeholder="请输入" /> -->
          <van-field
            v-if="formData.eyeShow2 || !addressEye"
            @input="changeAddress()"
            v-model="formData.addressUpdate"
            :maxlength="50"
            type="textarea"
            name="详细地址"
            rows="3"
            label="详细地址"
            placeholder="请输入"
          >
            <template #right-icon v-if="formData.address && addressEye">
              <van-icon class="password-icon" @click="openEye(formData, 'eyeShow2', 'address')" name="eye-o" />
            </template>
          </van-field>
          <van-field
            v-else
            v-model="formData.address"
            @input="changeAddress()"
            :maxlength="50"
            type="textarea"
            name="详细地址"
            rows="3"
            label="详细地址"
            placeholder="请输入"
          >
            <template #right-icon v-if="formData.address">
              <van-icon class="password-icon" @click="openEye(formData, 'eyeShow2', 'address')" name="closed-eye" />
            </template>
          </van-field>
        </van-collapse-item>

        <van-collapse-item title="补充信息" name="2"
          ><template #title>
            <div class="title">补充信息</div>
          </template>
          <template #value>
            <div class="right">
              <template v-if="activeNames.indexOf('2') != -1">收起<img src="@static/images/business/icon-arrow-up.png" alt="" /></template>
              <template v-else><span grey>展开</span><img src="@static/images/business/icon-arrow-down.png" alt="" /></template>
            </div>
          </template>
          <van-field v-model="formData.profession" :maxlength="15" name="职业" label="职业" placeholder="请输入" />
          <!-- <van-field v-model="formData.email"
						:rules="[{ validator: validatorEmail, message: '请输入正确的邮箱', trigger: 'onBlur' }]" type='email'
						name="邮箱" label="邮箱" placeholder="请输入" /> -->
          <van-field
            v-if="formData.eyeShow3 || !emailEye"
            @input="changeEmail()"
            v-model="formData.emailUpdate"
            :rules="[{ validator: validatorEmail, message: '请输入正确的邮箱', trigger: 'onBlur' }]"
            type="email"
            name="邮箱"
            label="邮箱"
            placeholder="请输入"
          >
            <template #right-icon v-if="formData.email && emailEye">
              <van-icon class="password-icon" @click="openEye(formData, 'eyeShow3', 'email')" name="eye-o" />
            </template>
          </van-field>
          <van-field
            v-else
            v-model="formData.email"
            @input="changeEmail()"
            :rules="[{ validator: validatorEmail, message: '请输入正确的邮箱', trigger: 'onBlur' }]"
            type="email"
            name="邮箱"
            label="邮箱"
            placeholder="请输入"
          >
            <template #right-icon v-if="formData.email">
              <van-icon class="password-icon" @click="openEye(formData, 'eyeShow3', 'email')" name="closed-eye" />
            </template>
          </van-field>
          <van-field v-model="formData.height" type="digit" :maxlength="3" name="身高(cm)" label="身高(cm)" placeholder="请输入" />
          <van-field
            v-model="formData.weight"
            type="number"
            name="体重(kg)"
            label="体重(kg)"
            placeholder="请输入"
            @input="validLength('weight')"
            @blur="validDot('weight')"
          />
          <van-field name="radio" class="radio-wrap" label="家庭关系">
            <template #input>
              <van-radio-group v-model="formData.familyRelationship" direction="horizontal">
                <van-radio v-for="(item, maritalIndex) in maritalStatusColumns" :key="maritalIndex" :name="item.key">
                  {{ item.text }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" class="radio-wrap" label="身体情况">
            <template #input>
              <van-radio-group v-model="formData.health" direction="horizontal">
                <van-radio v-for="(item, heakthIndex) in healthColumns" :key="heakthIndex" :name="item.key">{{ item.text }} </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field name="radio" class="radio-wrap" label="有无社保">
            <template #input>
              <van-radio-group v-model="formData.socialSecurity" direction="horizontal">
                <van-radio
                  v-for="(item, socialIndex) in [
                    { key: '1', text: '有社保' },
                    { key: '0', text: '无社保' }
                  ]"
                  :key="socialIndex"
                  :name="item.key"
                >
                  {{ item.text }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            v-model="formData.income"
            type="number"
            name="年收入(万元)"
            label="年收入(万元)"
            placeholder="请输入"
            @input="validLength('income')"
            @blur="validDot('income')"
          />
          <van-field
            v-model="formData.liabilities"
            type="number"
            name="贷款(元)"
            label="贷款(元)"
            placeholder="请输入"
            @input="validLength('liabilities')"
            @blur="validDot('liabilities')"
          />
          <van-field v-model="formData.spend" @input="validLength('spend')" type="number" name="月支出(元)" label="月支出(元)" placeholder="请输入" />
          <van-field v-model="formData.budget" @input="validLength('budget')" type="number" name="保险预算(元)" label="保险预算(元)" placeholder="请输入" />
        </van-collapse-item>

        <van-collapse-item title="需求信息" name="3">
          <template #title>
            <div class="title">需求信息</div>
          </template>
          <template #value>
            <div class="right">
              <template v-if="activeNames.indexOf('3') != -1">收起<img src="@static/images/business/icon-arrow-up.png" alt="" /></template>
              <template v-else><span grey>展开</span><img src="@static/images/business/icon-arrow-down.png" alt="" /></template>
            </div>
          </template>
          <van-field
            v-if="CUSTOMER_SOURCE_ADD"
            readonly
            clickable
            name="area"
            :value="CUSTOMER_SOURCE_ADD[formData.source]"
            label="客户来源"
            placeholder="请选择"
            @click="showPickerSource = true"
            ><template #right-icon>
              <img class="icon-arrow-down-select" src="@static/images/business/icon_arrow_down_grey.png" alt="" />
            </template>
          </van-field>
          <van-field name="checkboxGroup" label="客户需求" class="radio-wrap">
            <template #input>
              <van-checkbox-group v-model="formData.demand" direction="horizontal">
                <van-checkbox v-for="(item, demandIndex) in demandColumns" :key="demandIndex" :name="item.key" shape="square">
                  {{ item.text }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field name="checkboxGroup" label="为谁配置保险商业险" class="radio-wrap">
            <template #input>
              <van-checkbox-group v-model="formData.forWhoInsured" direction="horizontal">
                <van-checkbox v-for="(item, forWhoInsuredIndex) in forWhoInsuredColumns" :key="forWhoInsuredIndex" :name="item.key" shape="square">
                  {{ item.text }}
                </van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>
          <van-field name="radio" label="是否购买过商业险" class="radio-wrap">
            <template #input>
              <van-radio-group v-model="formData.businessRisk" direction="horizontal">
                <van-radio v-for="(item, socailIndex) in socialSecurityColumns" :key="socailIndex" :name="item.key">
                  {{ item.text }}
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field class="product-input" :maxlength="15" v-model="formData.focusProducts" name="关注的产品" label="关注的产品" placeholder="请输入" />
        </van-collapse-item>
      </van-collapse>
      <div class="confirm">
        <span class="btn" v-if="formData.visitorId" @click="bind">绑定已有客户</span>
        <van-button class="ok-bg-active active" round block type="info" native-type="submit">保存</van-button>
      </div>
    </van-form>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
    <van-popup v-model="showPickerBirth" position="bottom">
      <van-datetime-picker v-model="showDate" :min-date="minDate" :max-date="maxDate" type="date" @confirm="onConfirmBirth" @cancel="showPickerBirth = false" />
    </van-popup>
    <van-popup v-model="showLayer" position="bottom">
      <van-picker ref="areas" show-toolbar title="地区选择" :columns="allData" value-key="text" @cancel="handleCancle" @confirm="handleSure" />
    </van-popup>
    <van-popup v-model="showPickerSource" position="bottom">
      <van-picker show-toolbar :columns="sourceColumns" @confirm="onConfirmSource" @cancel="showPickerSource = false" />
    </van-popup>
  </div>
</template>
<script>
var timer;
import city from '@/api/allCity';
import dayjs from 'dayjs';
import { loading, common } from '@/api/mixins';
import regulars from '@/api/regulars';
export default {
  name: 'apps.okbao.addCustomer',
  mixins: [loading, common],
  computed: {},
  data() {
    return {
      canEdit: true,
      addressEye: true,
      cardNoEye: true,
      emailEye: true,
      showDate: '',
      minDate: '',
      maxDate: '',
      showPickerBirthKey: '',
      activeNames: ['1'],
      showLayer: false,
      formData: {
        id: '', //修改时传id
        name: null, //姓名
        sex: '1', //性别
        mobile: null, //手机号
        source: '', //客户来源
        cardType: '', //证件类型
        cardNo: '', //证件号
        birthDate: '', //出生年月
        isLong: '0', //证件有效期 1 长期 0短期
        customerInfoId: '', //客户信息表主键
        cardStartDate: '', //证件有效期起期
        cardEndDate: '', //证件有效期止期
        province: '', //省
        city: '', //市
        area: '', //客户所在区域
        address: '', //客户详细地址
        profession: '', //职业
        wechat: '', //微信号
        nation: '', //民族
        email: '', //邮箱
        height: '', //身高
        weight: '', //体重
        familyRelationship: '1', //家庭关系
        health: '1', //健康
        socialSecurity: '1', //社保
        income: '', //年收入
        liabilities: '', //负债
        spend: '', //月支出
        budget: '', //预算
        forWhoInsured: [], //为谁配置保险
        businessRisk: '1', //是否购买商业险
        focusProducts: '', //关注产品
        consultNum: '', //咨询次数
        demand: [], //客户需求
        remark: '', //备注
        visitorId: '' //访客表主键,@notes访客记录转为客户时用到
      },

      columns: [],
      healthColumns: [],
      maritalStatusColumns: [],
      socialSecurityColumns: [],
      forWhoInsuredColumns: [],
      demandColumns: [],
      isLongColumns: [],
      sourceColumns: [],
      sexColumns: [],
      showPicker: false,
      showPickerBirth: false,
      showPickerSource: false,
      CUSTOMER_SOURCE_ADD: {},
      CARD_TYPE: {}
    };
  },
  watch: {
    'formData.cardType': {
      handler(newVal, oldVal) {
        if (newVal == '06') {
          this.formData.isLong = '0';
          this.formData.cardStartDate = '';
          this.formData.cardEndDate = '';
        }
      },
      immediate: true
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem('IMPORT_CUSTOMER_INFO');
  },
  created() {
    this.allData = this.filterProvince(city);
    this.formData.id = this.$route.query.id; // 修改客户信息
    this.formData.visitorId = this.$route.query.visitorId;
    if (this.formData.id) {
      this.$tools.setWebTitle('修改客户信息');
      this.getCustomerInfo();
    } else if (this.$route.query.visitorId) {
      this.$tools.setWebTitle('转为客户');
    } else {
      this.addressEye = false;
      this.cardNoEye = false;
      this.emailEye = false;
      this.$tools.setWebTitle('新增客户');
    }
    if (sessionStorage.getItem('IMPORT_CUSTOMER_INFO')) {
      let info = JSON.parse(sessionStorage.getItem('IMPORT_CUSTOMER_INFO'));
      this.formData.name = info.fullName;
      this.formData.mobile = info.phones;
    }
    this.getDicByType({
      type: 'CARD_TYPE'
    }).then(res => {
      //证件类型
      res = {
        '01': '身份证',
        '06': '户口本'
      };
      this.CARD_TYPE = res;
      for (let key in res) {
        this.columns.push({
          text: res[key],
          key
        });
      }
      this.columns.sort((a, b) => {
        return Number(a.key) - Number(b.key);
      });
    });
    this.$http({
      url: '/app/customer/querySourceList',
      type: 'POST',
      data: {}
    }).then(res => {
      this.sourceColumns = res.data.map(item => {
        return {
          text: item.name,
          key: item.code
        };
      });
      res.data.forEach(item => {
        this.CUSTOMER_SOURCE_ADD[item.code] = item.name;
      });
    });
    this.getDicByType({
      type: 'CARD_IS_LONG'
    }).then(res => {
      for (let key in res) {
        this.isLongColumns.push({
          text: res[key],
          key
        });
      }
    });
    this.getDicByType({
      type: 'CUSTOMER_HEALTH'
    }).then(res => {
      for (let key in res) {
        this.healthColumns.push({
          text: res[key],
          key
        });
      }
    });
    this.getDicByType({
      type: 'MARITAL_STATUS'
    }).then(res => {
      for (let key in res) {
        this.maritalStatusColumns.push({
          text: res[key],
          key
        });
      }
    });
    this.getDicByType({
      type: 'IS_TRUE'
    }).then(res => {
      for (let key in res) {
        this.socialSecurityColumns.push({
          text: res[key],
          key
        });
      }
    });
    this.getDicByType({
      type: 'SEX'
    }).then(res => {
      for (let key in res) {
        this.sexColumns.push({
          text: res[key],
          key
        });
      }
    });
    this.getDicByType({
      type: 'SUBSCRIBE_RELATION'
    }).then(res => {
      for (let key in res) {
        this.forWhoInsuredColumns.push({
          text: res[key],
          key
        });
      }
    });
    this.getDicByType({
      type: 'SUBSCRIBE_DEMAND'
    }).then(res => {
      for (let key in res) {
        this.demandColumns.push({
          text: res[key],
          key
        });
      }
    });
  },
  methods: {
    changeCardNo() {
      if (!this.formData.cardNoUpdate && this.formData.cardNoUpdate != '') {
        this.formData.cardNoUpdate = this.formData.cardNo;
      }
      this.cardNoEye = false;
    },
    changeAddress() {
      if (!this.formData.addressUpdate && this.formData.addressUpdate != '') {
        this.formData.addressUpdate = this.formData.address;
      }
      this.addressEye = false;
    },
    changeEmail() {
      if (!this.formData.emailUpdate && this.formData.emailUpdate != '') {
        this.formData.emailUpdate = this.formData.email;
      }

      this.emailEye = false;
    },
    openEye(item, keyName, name) {
      let operationType;
      if (name == 'mobile') {
        operationType = 2;
      } else if (name == 'cardNo') {
        operationType = 1;
      } else if (name == 'address') {
        operationType = 5;
      } else if (name == 'email') {
        operationType = 4;
      }
      if (!item[keyName]) {
        this.descrypt(
          {
            query: item.id,
            operationFunction: 6,
            operationType: operationType
          },
          item,
          name + 'Update',
          'orderInuser_6_1'
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        if (this.formData.cardNoUpdate == '') {
          delete this.formData.cardNoUpdate;
        }

        if (this.formData.emailUpdate == '') {
          delete this.formData.emailUpdate;
        }

        if (this.formData.addressUpdate == '') {
          delete this.formData.addressUpdate;
        }
        this.$set(item, keyName, false);
      }
    },
    importCustomer() {
      let vm = this;
      // let res = [{
      // 	fullName: '小瓜',
      // 	phones: [{
      // 		phone: '13200001111'
      // 	}, {
      // 		phone: '13211111111'
      // 	}]
      // },{
      // 	fullName: '呱宝',
      // 	phones: [{
      // 		phone: '13222221111'
      // 	}, {
      // 		phone: '13265567890'
      // 	}]
      // }]
      // vm.mobileImport(res);
      // return
      if (this.$config.isApp) {
        this.$app.getAddressBook(
          res => {
            if (typeof res == 'string') {
              try {
                res = JSON.parse(res);
              } catch (error) {}
            }
            vm.mobileImport(res);
          },
          err => {
            vm.$notice.msg(err);
          }
        );
      }
    },
    mobileImport(list) {
      let loadings = this.$notice.loading('正在导入通讯录');
      this.$http({
        type: 'POST',
        url: '/app/customer/queryImport',
        data: list
      })
        .then(res => {
          this.$notice.close(loadings);
          sessionStorage.setItem('ADDRESS_BOOK_CUSTOMER_LIST', JSON.stringify(res.data));
          this.$router.push({
            path: '/apps/business/importCustomer',
            query: {
              type: 1
            }
          });
        })
        .catch(res => {
          this.$notice.close(loadings);
        });
    },
    filterProvince(arr) {
      const area = arr.map(item => ({
        text: item.name,
        children: item.children && item.children.length > 0 ? this.filterProvince(item.children) : null
      }));
      return area;
    },
    bind() {
      this.$router.push({
        path: '/apps/business/bindCustomer',
        query: {
          type: 1,
          visitorId: this.formData.visitorId
        }
      });
    },
    getCustomerInfo() {
      this.$http({
        url: '/app/customer/detail',
        type: 'GET',
        data: {
          id: this.formData.id
        }
      }).then(res => {
        console.log(res);
        let obj = res.data;
        if (!obj.mobile) {
          this.canEdit = true;
        } else {
          this.canEdit = false;
        }
        for (let key in this.formData) {
          if (key == 'forWhoInsured' || key == 'demand') {
            this.formData[key] = res.data[key].split(',');
          } else if (obj.hasOwnProperty(key)) {
            this.formData[key] = res.data[key];
          }
        }
      });
    },
    showPickerBirthFn(key) {
      this.showPickerBirthKey = key;
      this.minDate = new Date(dayjs().subtract(100, 'year').startOf('year').format());
      this.maxDate = new Date(dayjs().format());
      this.showDate = new Date(this.formData[key] ? this.formData[key] : this.maxDate);
      if (key == 'cardEndDate') {
        //日期选择范围为今天开始到50年后的12月31日
        this.minDate = new Date(dayjs().format());
        this.maxDate = new Date(dayjs().add(50, 'year').endOf('year').format());
        this.showDate = new Date(this.formData[key] ? this.formData[key] : this.minDate);
      }
      this.showPickerBirth = true;
    },
    validLength(key, num = 4) {
      if (!this.formData[key]) return;
      console.log(this.formData[key]);
      let val = '';
      let reg = /^\d{0,3}(\.?\d{0,2})/g; //小数点后最多保留2位小数，有效数字不超过5位
      if (key == 'liabilities' || key == 'spend' || key == 'budget' || key == 'income') {
        //贷款 小数点后最多保留2位小数，有效数字不超过10位
        reg = /^\d{0,8}(\.?\d{0,2})/g;
      }
      val = this.formData[key].match(reg)[0];
      this.formData[key] = val;
    },
    validDot(key) {
      if (!this.formData[key]) return;
      let val = this.formData[key];
      if (val.split('.').length > 1 && val.split('.')[1] == '') {
        val = val.split('.')[0];
      }
      if (val.indexOf('.') != -1) {
        val = ~~val.split('.')[0] + '.' + val.split('.')[1];
      } else {
        val = ~~val;
      }
      this.formData[key] = val;
    },
    validatorEmail() {
      if (!this.formData.email) {
        return true;
      }
      return regulars.isEmail(this.formData.emailUpdate);
    },
    validatorPhone() {
      return regulars.isPhone(this.formData.mobile);
    },
    validatorSfz() {
      if (!this.formData.cardNo || this.formData.cardType != '01' || this.formData.cardNo.indexOf('*') != -1) {
        return true;
      }
      let tmp = regulars.issfz(this.formData.cardNo);
      if (tmp) {
        this.formData.sex = this.$tools.IdCard(this.formData.cardNo, 2);
        this.formData.birthDate = dayjs(this.$tools.IdCard(this.formData.cardNo, 1)).format('YYYY-MM-DD');
      }
      return tmp;
    },
    //控制弹窗显示
    showDatas(type) {
      setTimeout(_ => {
        if (type == 1) {
          this.showLayer = true;
        } else if (type == 2) {
          this.showLayer = false;
        }
      }, 100);
    },
    getCityName(e) {
      let name = '';
      for (let k = 0; k < e.length; k++) {
        name += e[k] ? e[k] + ' ' : '';
      }
      console.log(name);
      return name;
    },
    handleCancle() {
      //munt 选择回调-取消
      this.showDatas(2);
    },
    handleSure(e, v) {
      //munt 选择回调-确认
      console.log(e);
      this.showDatas(2);
      this.formData.province = e[0];
      this.formData.city = e[1];
      this.formData.area = e[2];
      // this.formData.area = this.getCityName(e);
    },
    onSubmit() {
      let loadings = this.$notice.loading('正在添加客户...');
      clearTimeout(timer);
      timer = setTimeout(() => {
        let apiPermissionCode = '';
        if (this.formData.id) {
          apiPermissionCode = 'APP_CUSTOMER_UPDATE';
        } else if (this.$route.query.visitorId) {
          apiPermissionCode = 'APP_VISITOR_TONEW';
        } else {
          apiPermissionCode = 'APP_CUSTOMER_ADD';
        }
        this.$http({
          url: this.formData.visitorId ? '/app/visitRecord/addCustomer' : '/app/customer/update',
          type: 'POST',
          data: {
            ...this.formData,
            forWhoInsured: this.formData.forWhoInsured.filter(i => i).join(),
            demand: this.formData.demand.filter(i => i).join()
          },
          apiPermissionCode
        })
          .then(res => {
            this.$notice.close(loadings);
            this.$notice.msg('操作成功');
            this.$router.back();
          })
          .catch(() => {
            this.$notice.close(loadings);
          });
      }, 1000);
    },
    onConfirm(value) {
      this.formData.cardType = value.key;
      this.showPicker = false;
    },
    onConfirmSource(value) {
      this.formData.source = value.key;
      this.showPickerSource = false;
    },
    onConfirmBirth(time) {
      let day = dayjs(time).format('YYYY-MM-DD');
      this.formData[this.showPickerBirthKey] = day;
      this.showPickerBirth = false;
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
*[grey] {
  color: #515a6e;
}

.import {
  font-size: 26px;
  line-height: 37px;
  color: #fc650b;
  text-decoration: underline;
}

.main {
  margin-bottom: 160px;
}

.icon-arrow-down-select {
  width: 26px;
  margin-right: 10px;
}

.addCustomer {
  .title {
    font-weight: 600;
    font-size: 34px;
    line-height: 48px;
    color: #13233f;
  }

  .right {
    font-size: 26px;
    line-height: 44px;
    color: #fc650b;

    // display: flex;
    // align-items: center;
    img {
      display: inline-table;
      vertical-align: middle;
      width: 14px;
      height: 8px;
      margin-left: 8px;
    }
  }

  /deep/.van-checkbox__label {
    margin-left: 12px;
    font-size: 30px;
    color: #13233f;
  }

  /deep/.van-collapse-item--border::after {
    border-top: none;
  }

  /deep/.van-collapse-item__content {
    padding: 0;

    .van-checkbox {
      margin-bottom: 26px;
      margin-right: 48px;
    }

    .van-checkbox__icon {
      width: 34px;
      height: 34px;
      background-image: url('~static/images/business/icon_uncheck.png');
      background-size: 100%;

      .van-icon {
        display: none;
      }
    }

    .van-checkbox__icon--checked {
      background-image: url('~static/images/business/icon_check.png');
      background-size: 100%;
    }

    .van-radio--horizontal {
      margin-right: 100px;
      margin-bottom: 26px;

      .van-radio__label {
        font-size: 30px;
        color: #13233f;
        margin-left: 10px;
      }

      .van-radio__icon--checked {
        background-image: url('~static/images/business/icon_circle.png');
        background-size: 100%;

        .van-icon-success {
          display: none;
        }
      }

      .van-radio__icon {
        font-size: 36px;
        width: 36px;
        height: 36px;
      }
    }

    .van-cell__title {
      flex: 0 0 172px;
      margin-right: 44px;
      font-size: 30px;
      color: #515a6e;
    }

    .van-cell__value {
      font-size: 30px;
      color: #17233d;
    }

    .van-cell--required {
      .van-cell__title {
        position: relative;

        & ::after {
          // position: absolute;
          right: 0px;
          color: #ee0a24;
          font-size: 32px;
          content: ' *';
        }
      }
    }

    .van-cell--required::before {
      content: none;
    }

    .van-cell {
      padding: 34px 30px;
      line-height: 42px;
      position: relative;

      &::after {
        content: '';
        position: absolute;
        border-bottom: 1px solid #ececec;
        height: 0;
        display: inline-block;
      }
    }
  }

  .radio-cell .van-cell {
    padding: 34px 30px 8px;
  }

  .radio-wrap {
    padding: 34px 30px 8px !important;

    /deep/.van-cell__title {
      padding-bottom: 26px;
    }
  }

  /deep/.van-cell--clickable {
    .van-cell__right-icon {
      display: none;
    }
  }

  .confirm {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border-top: 1px solid #ececec;
    background-color: #fff;
    display: flex;
    padding: 20px 30px;

    .btn {
      flex: 1;
      height: 80px;
      opacity: 1;
      margin: 0 auto;
      border: 1px solid #dddddd;
      border-radius: 10px;
      font-size: 32px;
      color: #17233d;
      text-align: center;
      line-height: 80px;
    }

    .van-button {
      flex: 1;
      font-size: 32px;
      height: 80px;
      background: #ff8b00;
      opacity: 1;
      border-radius: 10px;
      margin: 0 auto;
      padding: 0;
      border-color: #ff8b00;
    }

    & :nth-child(2) {
      margin-left: 20px;
    }
  }
}

.van-hairline--top-bottom::after {
  border-width: 0;
}

/deep/ .product-input {
  &.van-cell::after {
    border-bottom: none !important;
  }
}
</style>
